// extracted by mini-css-extract-plugin
export default {"list":"adefault_list__YT1YW","loadMore":"adefault_loadMore__mbc-6","description":"adefault_description__-68IR"};